import { Component, OnInit, Inject} from '@angular/core';
import {MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material';

@Component({
  selector: 'app-charts-dialog',
  templateUrl: './charts-dialog.component.html',
  styleUrls: ['./charts-dialog.component.css']
})
export class ChartsDialogComponent implements OnInit {
	showGoogle: boolean = false
  constructor(public dialogRef: MatDialogRef<ChartsDialogComponent>, @Inject(MAT_DIALOG_DATA) public data: any) { }

  ngOnInit() {  
  	setTimeout(this.showGoogleChart.bind(this),1000)
  }

  showGoogleChart(){
    this.showGoogle = true
  }
}
